import React from "react";
import { HeartPulse, Shield, Flower2, Baby, Sparkles, Wind } from "lucide-react";
import { useLang } from "../../translations";
import { FadeUp, Stagger, StaggerItem } from "./Reveal";

const icons = [HeartPulse, Shield, Flower2, Baby, Sparkles, Wind];
// bento spans: create asymmetry on lg
const spans = [
  "md:col-span-7", "md:col-span-5",
  "md:col-span-5", "md:col-span-7",
  "md:col-span-7", "md:col-span-5",
];

export const Expertise = () => {
  const { t } = useLang();
  return (
    <section id="expertise" data-testid="expertise-section" className="py-24 md:py-36 bg-sand">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
        <FadeUp>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
            <div>
              <p className="text-xs uppercase tracking-[0.28em] text-sage mb-4">{t.expertise.label}</p>
              <h2 className="font-heading text-4xl md:text-5xl lg:text-[3.4rem] text-ink leading-[1.05] tracking-tight max-w-2xl">
                {t.expertise.title}
              </h2>
            </div>
          </div>
        </FadeUp>

        <Stagger className="grid grid-cols-1 md:grid-cols-12 gap-5">
          {t.expertise.items.map((item, i) => {
            const Icon = icons[i];
            return (
              <StaggerItem key={i} className={spans[i]}>
                <div
                  data-testid={`expertise-card-${i}`}
                  className="group h-full min-h-[220px] flex flex-col justify-between rounded-2xl border border-ink/10 bg-cream p-8 transition-colors duration-500 hover:border-sage hover:bg-white"
                >
                  <div className="h-12 w-12 rounded-full bg-sage/12 flex items-center justify-center text-sage transition-colors duration-500 group-hover:bg-sage group-hover:text-cream">
                    <Icon size={22} strokeWidth={1.6} />
                  </div>
                  <div className="mt-8">
                    <h3 className="font-heading text-2xl md:text-3xl text-ink">{item.t}</h3>
                    <p className="mt-3 text-muted2 leading-relaxed">{item.d}</p>
                  </div>
                </div>
              </StaggerItem>
            );
          })}
        </Stagger>
      </div>
    </section>
  );
};
